var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcClock20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.992 2C14.416 2 18 5.584 18 10s-3.584 8-8.008 8C5.576 18 2 14.416 2 10s3.576-8 7.992-8m.508 2.5a.5.5 0 0 0-.492.41L10 5v5.5H6.5a.5.5 0 0 0-.09.992l.09.008h4l.09-.008a.5.5 0 0 0 .402-.402L11 11V5a.5.5 0 0 0-.5-.5"
})));
export default SvgIcClock20X20;